import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Globe, Plus } from 'lucide-react'
import { getAllNetworks } from '@/config/networks'
import SearchBar from '@/components/SearchBar'

const Networks = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState('')

  // Solo OMDB/BSC de las redes propias de la app, más todas las que el usuario agregó
  const visibleNetworks = getAllNetworks().filter(
    (network) => network.id === 'omdb' || network.id === 'bsc' || network.isCustom
  )

  const filteredNetworks = visibleNetworks.filter((network) =>
    network.name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <div className="flex flex-col w-full max-w-xl mx-auto gap-6 pt-4">
      <div className="hidden lg:flex items-center gap-4">
        {/* <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-full bg-text-main/5 hover:bg-text-main/10 transition-colors"
        >
          <ArrowLeft className="w-6 h-6 text-text-main" />
        </button> */}
        <h1 className="text-3xl font-bold text-text-main">
          {t('networks.title')}
        </h1>
      </div>

      <SearchBar
        placeholder={t('networks.search_placeholder')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <p className="text-xs text-text-secondary uppercase tracking-widest font-bold ml-1">
        {t('networks.enabled_networks_section')}
      </p>

      <div className="bg-card border border-border-base rounded-xl shadow-sm divide-y divide-border-base overflow-hidden">
        {filteredNetworks.length === 0 ? (
          <div className="p-6 text-center text-text-secondary text-sm">
            {t('networks.no_results')}
          </div>
        ) : (
          filteredNetworks.map((network) => (
            <button
              key={network.id}
              onClick={() => navigate(`/network-details/${network.id}`)}
              className="w-full flex items-center gap-3 px-4 py-3.5 hover:bg-card-hover transition-colors text-left"
            >
              <div className="w-7 h-7 rounded-full overflow-hidden bg-primary/20 flex items-center justify-center shrink-0">
                {network.logoUrl ? (
                  <img
                    src={network.logoUrl}
                    alt={network.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <Globe className="w-4 h-4 text-primary" />
                )}
              </div>
              <span className="text-sm font-medium text-text-main flex-1">
                {network.name}
              </span>
              {network.isTestnet && (
                <span className="text-[10px] px-1 rounded bg-orange-500/20 text-orange-500 border border-orange-500/30">
                  {t('networks.testnet_badge')}
                </span>
              )}
              {network.isCustom && (
                <span className="text-[10px] px-1 rounded bg-primary/20 text-primary border border-primary/30">
                  {t('networks.custom_badge')}
                </span>
              )}
            </button>
          ))
        )}
      </div>

      <button
        onClick={() => navigate('/add-network')}
        className="btn-gradient-fill flex font-bold items-center justify-center gap-2 rounded-full py-4 px-6"
      >
        <Plus className="w-5 h-5" />
        {t('networks.add_network')}
      </button>
    </div>
  )
}

export default Networks
